/****************************************************
 * Module Name:  receiveLocationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import { MdLocationOn } from "react-icons/md";

const ReceiveLocationModal = ({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  loading
}) => {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);

  const saveHandler = () => {
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(remark)) {
          //need to add locationId here and in the parent component if need for validation
          handleSave(remark);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(remark);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            change location validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Do you want to receive the stones ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{
            "& .Mui-disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12) !important",
              color: "rgba(0, 0, 0, 0.26) !important"
            }
          }}>
            <LoadingButton
              variant="contained"
              onClick={saveHandler}
              type="Submit"
              sx={{ mr: 3 }}
              loading={loading}
              loadingPosition="start"
              startIcon={<MdLocationOn />}
            >
              Receive
            </LoadingButton>
          </Box>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReceiveLocationModal;
